import { issueBadgeClasses } from './badgeBase';
import { clsx } from 'clsx';
import type { TicketStatus } from '@overlayqa/shared';

const STATUS_CONFIG: Record<string, { label: string; bg: string; text: string }> = {
  open: { label: 'Open', bg: 'bg-[var(--color-status-open-bg)]', text: 'text-[var(--color-status-open-text)]' },
  'in-progress': { label: 'In Progress', bg: 'bg-[var(--color-status-in-progress-bg)]', text: 'text-[var(--color-status-in-progress-text)]' },
  resolved: { label: 'Resolved', bg: 'bg-[var(--color-status-resolved-bg)]', text: 'text-[var(--color-status-resolved-text)]' },
  verified: { label: 'Verified', bg: 'bg-[var(--color-status-verified-bg)]', text: 'text-[var(--color-status-verified-text)]' },
  closed: { label: 'Closed', bg: 'bg-[var(--color-status-closed-bg)]', text: 'text-[var(--color-status-closed-text)]' },
};

interface StatusBadgeProps {
  status: TicketStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.closed;
  return (
    <span className={clsx(issueBadgeClasses, config.bg, config.text)}>
      {/* The dot is an SVG as TALL as the Severity and Type icons (10px), and the
          TAG is load-bearing. An inline-flex pill takes its baseline from its first
          child; a bare 5px dot gave this badge a higher baseline than its neighbours,
          so it rendered 1.75px lower than them in the same table row. A 10px <span>
          around the dot measured the SAME 1.75px, because a box with a child takes
          its baseline from that child. An svg has no baseline, so the pill falls
          back to the svg's own box, exactly as it does for the sibling icons: 0px.
          All three read off /design-system in real Chromium, 2026-09-18
          (e2e/verify-issue-badge-layout.ts). 5px wide, so the badge keeps its width. */}
      <svg viewBox="0 0 5 10" className="w-[5px] h-[10px] flex-shrink-0" aria-hidden="true">
        <circle cx="2.5" cy="5" r="2.5" fill="currentColor" />
      </svg>
      {config.label}
    </span>
  );
}
